<template>
	<div class="commission l">
		<ul class="top">
			<li @click="yongjin(0)" :class="{active:Isactive==0}">
				<p>未付款</p>
			</li>
			<li @click="yongjin(1)" :class="{active:Isactive==1}">
				<p>已付款</p>
			</li>
			<li @click="yongjin(2)" :class="{active:Isactive==2}">
				<p>等待成</p>
			</li>
			<li @click="yongjin(3)" :class="{active:Isactive==3}">
				<p>已分成</p>
			</li>
			<li @click="yongjin(4)" :class="{active:Isactive==4}">
				<p>已取消</p>
			</li>
		</ul>
		<div class="under">
			<div class="thead">
				<p>ID</p>
				<p>订单编号</p>
				<p>获得佣金</p>
				<p>记录生成时间</p>
				<p>状态</p>
			</div>
			<div class="same">
				<p>1</p>
				<p>201709121136443226</p>
				<p>9.00</p>
				<p>2017-09-12</p>
				<p>未付款</p>
			</div>
			<div class="same">
				<p>2</p>
				<p>201709121136443226</p>
				<p>9.00</p>
				<p>2017-09-12</p>
				<p>未付款</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				Isactive: '',
			}
		},
		created() {},
		methods: {
			yongjin(index) {
				this.Isactive = index
			},
		}
	}
</script>

<style lang="less" scoped>
	.l {
		float: left;
	}
	
	.r {
		float: right;
	}
	
	.center {
		width: 1200px;
		margin: 0 auto;
		height: 100%;
	}
	
	.commission {
		width: 980px;
		background: #fff;
		margin: 16px 0;
		padding-bottom: 40px;
		height: 357px;
		.top {
			height: 37px;
			border-bottom: 1px solid #e7e7e7;
			margin: 14px 17px 23px;
			;
			li {
				cursor: pointer;
				float: left;
				width: 104px;
				text-align: center;
				height: 37px;
				font-size: 14px;
				color: #666;
				p {
					line-height: 16px;
					border-right: 1px solid #eee;
					margin-top: 10px;
				}
			}
			li:last-child {
				p {
					border-right: 0;
				}
			}
		}
		.active {
			border-bottom: 2px solid #d19e29;
			color: #d19e29 !important;
		}
		.under {
			margin: 23px 17px 0;
			border: 1px solid #e7e6e6;
			overflow: hidden;
			.thead {
				overflow: hidden;
				height: 38px;
				background: #f5f5f5;
				line-height: 38px;
			}
			.same {
				overflow: hidden;
				line-height: 38px;
				border-top: 1px solid #e7e6e6;
			}
			p {
				font-size: 12px;
				color: #333;
				float: left;
				text-align: center;
			}
			p:nth-of-type(1) {
				width: 87px;
				margin-right: 147px;
			}
			p:nth-of-type(2) {
				margin-left: 128px;
				width: 104px;
			}
			p:nth-of-type(3) {
				margin-left: 47px;
				width: 105px;
			}
			p:nth-of-type(4) {
				margin-left: 61px;
				width: 127px;
			}
			p:nth-of-type(5) {
				width: 106px;
			}
			.sames {
				p {
					color: #d19e29 !important;
				}
			}
		}
	}
</style>